<arpio-center-panel>
  <h3 class="panel-title">Access Denied</h3>
  <div class="margin-top">
    You don't have permission to access this resource. This may be because your account doesn't have the required
    permissions, or your authentication has expired. Please contact your account administrator if you believe this is an
    error.
  </div>
  <div class="margin-top actions">
    @if (hasHistory) {
      <button class="primary-button" (click)="goBack()">
        <i class="fa-utility fa-semibold fa-arrow-left"></i>
        Go Back
      </button>
    }
    <button class="arpio-secondary-button" (click)="logout()">
      Log Out
      <i class="fa-utility fa-semibold fa-arrow-right-from-bracket"></i>
    </button>
  </div>
</arpio-center-panel>
